import React from 'react';
import PropTypes from 'prop-types';
import {
  GoogleApiWrapper,
  Map,
  Marker,
} from 'google-maps-react';
import { get } from 'lodash';
import markerImage from '../Map/MarkerImage';
import { getProviderLatLng } from '../../utils';

const ProviderMapComp = (props) => {
  const {
    google,
    provider,
  } = props;

  const coordinates = getProviderLatLng(provider);
  const markerColor = get(window, 'uuSearchSettings.markers-color') || 'red';
  const iconSize = 20;

  return (
    <div className="uu-provider-map">
      <Map
        google={google}
        zoom={16}
        initialCenter={coordinates}
      >
        <Marker
          icon={{
            url: markerImage(markerColor),
            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
            scaledSize: new google.maps.Size(iconSize, iconSize),
          }}
          name={provider.name}
          position={coordinates}
          provider={provider}
        />
      </Map>
    </div>
  );
};

ProviderMapComp.propTypes = {
  google: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
};

export default GoogleApiWrapper(() => ({
  apiKey: (get(window, 'uuSearchSettings.google-map-api-key', '')),
}))(ProviderMapComp);



// WEBPACK FOOTER //
// ./public/js/components/ProviderMap/index.jsx